import { firebaseConfig } from '../constants';
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { localFcmFake } from './localFcm.fake';
import {
  MessagePayload,
  Messaging,
  // getMessaging,
  getToken,
  onMessage,
} from 'firebase/messaging';

const isLocalMode =
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_TECO_LOCAL_MODE === 'true';
const authEmulatorUrl = process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_URL;
const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);

if (isLocalMode && authEmulatorUrl) {
  connectAuthEmulator(firebaseAuth, authEmulatorUrl, {
    disableWarnings: true,
  });
}

let messaging: Messaging;

// const getMessage = async () => {
//   try {
//     messaging = getMessaging(firebaseApp);
//   } catch (error) {}
// };
// getMessage();

const getMessagingToken = async () => {
  if (isLocalMode) {
    return localFcmFake.getToken();
  }
  if (!messaging) return;
  let currentToken = '';
  try {
    currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });
    return currentToken;
  } catch (error) {
    console.log('An error occurred while retrieving token. ', error);
  }
};

const onMessageListener = (
  callbackFn: (payload: MessagePayload) => void,
): Promise<() => void> => {
  if (isLocalMode) return localFcmFake.onMessage(callbackFn);
  return new Promise<() => void>((resolve) => {
    if (messaging) {
      resolve(onMessage(messaging, callbackFn));
    }
  });
};

export { firebaseApp, firebaseAuth, getMessagingToken, onMessageListener };
